import React from 'react';
import { Header } from 'widgets';
import { PageLayout } from 'shared/ui';
import styles from './cookie-policy.page.module.scss';

export const CookiePolicyPage: React.FC = () => {
  return (
    <PageLayout>
      <Header hideSignInButton />
      <div className={styles.page__content}>
        <h1 className={styles.content__title}>Политика использования cookie</h1>
        <p className={styles.content__date}>
          Дата вступления в силу: 17.06.2026
        </p>
        <p className={styles.content__date}>
          Оператор: Самозанятый, ИНН 212710062014
        </p>

        <section className={styles.content__section}>
          <h2>1. Что такое cookie</h2>
          <p>
            Cookie — это небольшие текстовые файлы, которые сохраняются на
            устройстве Пользователя при посещении веб-сайта. Они позволяют
            запоминать действия и предпочтения Пользователя для улучшения работы
            Сервиса.
          </p>
          <p>
            В рамках Сервиса BookUp используется локальное хранилище
            (localStorage) браузера для аналогичных целей.
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>2. Какие данные мы используем</h2>
          <p>
            Сервис может использовать следующие типы данных локального хранения:
          </p>
          <ul>
            <li>Токены авторизации (access token, refresh token);</li>
            <li>Настройки интерфейса Пользователя;</li>
            <li>Данные о сессии для обеспечения безопасности;</li>
            <li>Временные данные для ускорения работы Сервиса.</li>
          </ul>
        </section>

        <section className={styles.content__section}>
          <h2>3. Цели использования</h2>
          <p>Локальное хранение данных используется для:</p>
          <ul>
            <li>Обеспечения авторизации и аутентификации Пользователя;</li>
            <li>Сохранения настроек и предпочтений Пользователя;</li>
            <li>
              Улучшения производительности и удобства использования Сервиса;
            </li>
            <li>Обеспечения безопасности учетной записи.</li>
          </ul>
        </section>

        <section className={styles.content__section}>
          <h2>4. Сторонние сервисы</h2>
          <p>
            Сервис BookUp не использует сторонние аналитические и рекламные
            cookie-сервисы, которые отслеживают поведение Пользователя на
            сторонних ресурсах.
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>5. Управление localStorage</h2>
          <p>
            Пользователь может в любой момент очистить локальное хранилище
            браузера через настройки браузера. После очистки некоторые функции
            Сервиса могут стать недоступными до повторной авторизации.
          </p>
          <p>
            Отключение localStorage может привести к некорректной работе Сервиса
            или невозможности его использования.
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>6. Согласие</h2>
          <p>
            Продолжая использование Сервиса BookUp, Пользователь подтверждает
            свое согласие на использование локального хранилища браузера в
            целях, указанных в настоящей Политике.
          </p>
        </section>

        <section className={styles.content__section}>
          <h2>7. Контактная информация</h2>
          <p>
            По всем вопросам, связанным с использованием cookie и локального
            хранения данных, обращайтесь по адресу: support@book-up.ru.
          </p>
        </section>
      </div>
    </PageLayout>
  );
};
